import type { ComponentProps, ReactNode } from 'react';
import { PlainLink } from '@customerio/pluma-components/react';
import type { IconName } from '@customerio/pluma-icons';
import { Box, Icon, Text } from '@customerio/pluma-components/react';
import * as styles from './resource-link.css';

export interface ResourceLinkProps extends Omit<ComponentProps<typeof PlainLink>, 'children' | 'title'> {
  title: ReactNode;
  icon?: IconName;
  description?: string;
}

export function ResourceLink({ title, icon, description, className, ...linkProps }: ResourceLinkProps) {
  return (
    <PlainLink {...linkProps} className={[styles.container, className]}>
      {icon != null ? <Icon name={icon} size="sm" color="primary" mt="025" /> : null}
      <Box display="flex" flexDirection="column" gap="025" w="full">
        <Text size="sm" display="block">
          {title}
        </Text>
        {description != null ? (
          <Text size="xs" color="secondary">
            {description}
          </Text>
        ) : null}
      </Box>
    </PlainLink>
  );
}
